// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SignUpView_checkbox__bVoRu"};